<app-radio-group
	[labelOrientation]="labelOrientation"
	label="Management Type"
	[items]="managementTypes"
	type="compact"
	[ngModel]="managementType$ | async"
	(ngModelChange)="setManagementType($event)"
/>
